import React from 'react';
import baseStyles from "./styles.module.css.js";
import useStyleOverride from "../../../hooks/useStyleOverride.js";
import useComponentOverride from "../../../hooks/useComponentOverride.js";
export var OverlayHeader = _ref => {
  var {
    resultCount,
    triggerCollapse,
    sidebarLocation
  } = _ref;
  var styles = useStyleOverride('layouts/TwoColumnOverlayMap/OverlayHeader', baseStyles);
  var [OverlayToggleButton, OverlayHeaderText] = useComponentOverride('layouts/TwoColumnOverlayMapLayout/OverlayToggleButton', 'layouts/TwoColumnOverlayMapLayout/OverlayHeaderText');
  return /*#__PURE__*/React.createElement("div", {
    className: styles.OverlayHeader
  }, /*#__PURE__*/React.createElement(OverlayHeaderText, null), /*#__PURE__*/React.createElement(OverlayToggleButton, {
    onClick: triggerCollapse,
    direction: sidebarLocation === 'right' ? 'left' : 'right'
  }));
};
export default OverlayHeader;
//# sourceMappingURL=index.js.map